import { render, staticRenderFns } from "./MyProfilePremium.vue?vue&type=template&id=5d66e2f0&scoped=true&"
import script from "./MyProfilePremium.vue?vue&type=script&lang=js&"
export * from "./MyProfilePremium.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d66e2f0",
  null
  
)

export default component.exports